<template>
	<div class="flex justify-center w-full mt-3">
		<div v-if="getTasks.length > 0" class="w-full space-y-4">
			<BaseButton
				v-for="(task, index) in getTasks"
				:key="task.id"
				:index="index"
				class="py-4 px-2 w-full text-left odd:bg-gray-200 cursor-pointer"
				style="text-align: center"
				@click="$router.push({ name: 'AppsEmployeeRepairPlanTasksDetail', params: { taskid: task.id } })"
			>
				{{ task.name }}
			</BaseButton>
			<BaseButton
				class="btn-default w-full py-4 px-2 text-left bg-white cursor-pointer border-b font-bold"
				style="text-align: center"
				@click="customEntry"
			>
				{{ $t('custom_entry') }}
			</BaseButton>
		</div>
		<div v-else class="text-red-700 py-8 px-8 font-bold">{{ $t('enter_work_steps_first') }}</div>
	</div>
</template>

<script>
import AppsEmployee from '@/mixins/AppsEmployee';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
export default {
	name: 'AppsEmployeeRepairPlanTasks',
	components: { BaseButton },
	mixins: [AppsEmployee],
	data() {
		return {
			newTask: '',
		};
	},
	methods: {
		customEntry() {
			this.$swal({
				title: this.$t('custom_entry').toString(),
				text: this.$t('enter_text_for_step_input').toString(),
				cancelButtonText: this.$t('general.cancel').toString(),
				showCancelButton: true,
				confirmButtonText: 'OK',
				input: 'text',
			}).then(result => {
				if (result.value) {
					this.$store.commit('addTask', result.value);
					this.$router.push({ name: 'AppsEmployeeRepairPlanTasksDetail', params: { taskid: 0 } });
				}
			});
		},
	},
	computed: {
		getTasks() {
			return this.getAppsEmployeeDamageCase.repair_shop.repairPlanTasks.filter(e => e.id !== 0);
		},
	},
};
</script>

<style scoped></style>
